import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

export interface VantixUser {
  id: number;
  external_id: string;
  nombre: string;
  apellidos?: string | null;
  correo: string;
}

export interface VantixSsoTicket {
  login_url: string;
  expires_in?: number | null;
  expires_at?: string;
}

export interface VantixSyncResponse {
  success: boolean;
  message: string;
  data: any;
}

export interface VantixSsoTicketResponse {
  success: boolean;
  message: string;
  data: VantixSsoTicket;
}

export interface VantixAccessResponse {
  success: boolean;
  message: string;
  data: {
    login_url: string;
    expires_in?: number | null;
    user: VantixUser;
    synchronization?: any;
  };
}

@Injectable({
  providedIn: 'root',
})
export class UserExternalService {
  private readonly apiUrl =
    `${environment.apiUrl}/config/users_external`;

  constructor(private http: HttpClient) {}

  /**
   * Sincroniza el usuario local con Vantix.
   *
   * POST /config/users_external/:id/sync
   */
  syncUser(
    userId: number
  ): Observable<VantixSyncResponse> {
    return this.http.post<VantixSyncResponse>(
      `${this.apiUrl}/${userId}/sync`,
      {}
    );
  }

  /**
   * Genera un ticket SSO.
   *
   * POST /config/users_external/:id/sso-ticket
   */
  createSsoTicket(
    userId: number,
    returnTo = '/home'
  ): Observable<VantixSsoTicketResponse> {
    return this.http.post<VantixSsoTicketResponse>(
      `${this.apiUrl}/${userId}/sso-ticket`,
      {
        return_to: returnTo,
      }
    );
  }

  /**
   * Sincroniza al usuario y genera el acceso a Vantix.
   * Este es el endpoint recomendado para el frontend.
   *
   * POST /config/users_external/:id/access-vantix
   */
  accessVantix(
    userId: number,
    returnTo = '/home'
  ): Observable<VantixAccessResponse> {
    return this.http.post<VantixAccessResponse>(
      `${this.apiUrl}/${userId}/access-vantix`,
      {
        return_to: returnTo,
      }
    );
  }

  /**
   * Construye la dirección del endpoint que redirige directamente.
   *
   * GET /config/users_external/:id/redirect-vantix
   */
  getRedirectVantixUrl(
    userId: number,
    returnTo = '/home'
  ): string {
    const params = new HttpParams().set(
      'return_to',
      returnTo
    );

    return (
      `${this.apiUrl}/${userId}/redirect-vantix?` +
      params.toString()
    );
  }
}